import React, { useEffect } from "react";
import { observer } from "mobx-react";
import {
  generatePath,
  useParams,
  useLocation,
  useNavigate,
} from "react-router-dom";
import WorkoutStore from "stores/WorkoutStore";
import { Page } from "components/Layout";
import NavList from "../NavList/NavList";
import ROUTES from "navigation/routes";
import { Background } from "./styles";
import GridCollection from "components/GridCollection";
import { withTranslation, WithTranslation } from "react-i18next";

type Props = WithTranslation;

const WorkoutFamilyDetails: React.FC<Props> = observer(() => {
  const params = useParams<{ familyId: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const familyId = Number(params.familyId);

    const fetchData = async () => {
      try {
        if (!WorkoutStore.families.length) {
          await WorkoutStore.fetchFamilies();
        }
        WorkoutStore.fetchFamilyCategories(familyId);
      } catch (error) {
        console.error("Error loading family details:", error);
      }
    };
    fetchData();
  }, [params.familyId]);

  const onCategoryClick = (cat: any) => {
    navigate(
      generatePath(ROUTES.WORKOUT_CATEGORY_DETAILS_WORKOUTS, {
        categoryId: cat.id,
        workoutGroup: "all",
      }),
      { state: { id: cat.id, categoryTitle: cat.title, familyId: params.familyId, familyTitle: familyTitle  } },
    );
  };

  const familyTitle = (location.state as any)?.familyTitle;

  return (
    <Page
      title={familyTitle}
      contentBackground={
        <>
          <Background />
          <Background leftDots />
        </>
      }
      topNavigation={<NavList />}
      isLoading={WorkoutStore.isLoading}
    >
      <GridCollection
        items={WorkoutStore.familyCategories}
        onClick={onCategoryClick}
        withInfinityScroll
      />
    </Page>
  );
});

export default withTranslation()(WorkoutFamilyDetails);
